import {
  getSessionData,
  getVersionedCallbackUrl,
  redirectToWebform,
  setCookie,
} from "@repo/shared-utils/common-utils";
import { nclInsert, offerAPI, deleteFromCartApi } from "@repo/connection-manager";
import { Loan_Type } from "../../../api-client/src/constants/plCalculatorConstants";
import {
  NCL_JOURNEY_NAME,
  PDP_DETAILS,
  WHEELS_OFFER,
  customerType,
} from "../../../api-client/src/constants/util";
import type { SSORedirectHandler } from "../../../../apps/trading-mall-app/app/components/ClickHandler/RedirectionConfig.interface";
import { commonInsertParameters, getOrDefaultValue } from "@repo/shared-utils/insert-params";
import { getApplicationIdAndProdCode, getApplicationId } from "./utils";

export const nclHandler: SSORedirectHandler = async (data) => {
  const { mobileNo, custType } = await getSessionData();

  const product = Loan_Type.NCL;
  let response = undefined;
  const nclOffer = (await offerAPI(Loan_Type.NCL)) || [];
  if (nclOffer?.length && custType === customerType.ETB) {
    // display loader and redirecting to Bajaj Mall
    setCookie("redirectedToBajajMall", 0, "true");
    return;
  }

  const [applicationID, prodCode] = await getApplicationIdAndProdCode(data, ["NCL"]);
  const resume = applicationID !== undefined;

  // Set `currentWebformJourneyStartedPage` key so that "Go back and edit" feature on webform
  // takes users back to the page form where they started the journey.
  sessionStorage.setItem("currentWebformJourneyStartedPage", window.location.pathname);

  const appId = await getApplicationId(["NCL"]);
  if (appId) {
    await deleteFromCartApi({ appId, mobileNo, channel: "3in1" });
  }
  try {
    response = await nclInsert({
      ...commonInsertParameters({ appVersion: "v1" }),
      mobileNo: mobileNo,
      journeyName: NCL_JOURNEY_NAME,
      eventCode: WHEELS_OFFER,
      eventName: PDP_DETAILS,
      prodName: product,
      custType: getOrDefaultValue(custType),
      offerId: nclOffer[0]?.offerId ?? "",
      offerName: nclOffer[0]?.icorsOfferNameValue ?? "",
      offerAmt: nclOffer[0]?.icorsAmount ?? "",
      apiVersion: "v1",
      ...data.data?.nclInsert,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }

  const callbackUrl = await getVersionedCallbackUrl(data.mapping);
  redirectToWebform(
    callbackUrl.toString(),
    {
      applicationID: response?.id ?? applicationID,
      prodCode: response?.id ? "" : prodCode,
      product,
      custType,
      resume: false,
    },
    `new_car_loan/${resume ? "resume" : "new"}`
  );
};
